export default {"src":"/_next/static/media/UserPlus.31927666.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};